import state from './moduleCommunityUpdateState.js'
import mutations from './moduleCommunityUpdateMutations.js'
import actions from './moduleCommunityUpdateActions.js'
import getters from './moduleCommunityUpdateGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
